class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px -100px 0px" }
    );
    this.observer.observe(this);
  }
  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelectorAll("[data-wishlist-toggle]")
          .forEach((button) => {
            const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
            const productHandle = button.dataset.productHandle;
            if (wishlist.includes(productHandle)) {
              button.classList.add("in-wishlist", "remove");
              button.setAttribute("aria-label", "remove to wishlist");
            }
          });

        const allCards = document.querySelectorAll(".card-product");

        allCards.forEach((product) => {
          const slider = product.querySelector(".card__slider-container");

          product.addEventListener("click", (e) => {
            // Handle color swatches
            const colorOption = e.target.closest(
              ".card-product__color-option:not(.disabled)"
            );
            // Color Swatches Function
            if (colorOption) {
              e.preventDefault();
              handleColorSwatch(colorOption, product);
            }
          });
        });
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);
